import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Card } from '@/components/ui/card'
import { cn } from '@/lib/utils'

import { Conversations } from './Conversations'

type ChatListProps = {
  selectChat: (id?: string, inital?: boolean) => void
  activeChat?: string
  activeUser?: string
  modal?: React.ReactNode
}

export function ChatList(props: ChatListProps) {
  const { t } = useTranslation('chat')
  const [tab, setTab] = useState<'open' | 'closed'>('open')

  const tabs = [
    { key: 'open' as const, label: t('form.common.open') },
    { key: 'closed' as const, label: t('form.common.closed') }
  ]

  return (
    <Card className="min-h-[680px] space-y-5 p-5">
      <div className="flex items-center justify-between gap-3">
        <h3 className="m-0 font-display text-lg font-bold tracking-tight text-ink">
          {t('form.common.chats')}
        </h3>
        {props.modal}
      </div>

      <div className="flex justify-center">
        <div className="inline-flex gap-1 rounded-full border border-ink/[0.06] bg-ink/[0.03] p-1">
          {tabs.map((tabItem) => (
            <button
              key={tabItem.key}
              type="button"
              onClick={() => setTab(tabItem.key)}
              className={cn(
                'rounded-full border-0 px-4 py-1.5 text-sm font-semibold transition-colors',
                tab === tabItem.key
                  ? 'bg-white text-ink shadow-sm'
                  : 'bg-transparent text-muted-foreground hover:text-ink'
              )}
            >
              {tabItem.label}
            </button>
          ))}
        </div>
      </div>

      <Conversations
        selectChat={props.selectChat}
        isActive={tab === 'open'}
        activeChat={props.activeChat}
        activeUser={props.activeUser}
      />
    </Card>
  )
}
